import { createSelector } from 'reselect';
import { canUserEditEntity } from '../../../common/util/authUtils';
import { selectLoggedInUser } from '../userSelector';

const organizations = (state) => state.organizations.list;

const enrichWithEditPermissionCheck = (organizationList, loggedInUser) => {
  const { roleName: role, userId } = loggedInUser;

  return organizationList.map((organization) => {
    const canCurrentUserEditEntity = canUserEditEntity(
      organization.owners,
      userId,
      role
    );
    return {
      ...organization,
      canCurrentUserEditEntity,
    };
  });
};

const organizationSelector = createSelector(
  organizations,
  selectLoggedInUser,
  enrichWithEditPermissionCheck
);

export default organizationSelector;

const organizationStats = (state) => state.organizations.statbarData;
export const organizationsStatsSelector = createSelector(
  organizationStats,
  (stats) => stats
);

const listPageData = (state) => state.organizations.listPageData;
export const listPageDataSelector = createSelector(
  listPageData,
  (data) => data
);
